import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { services } from '../../mock/data';
import { Reveal, RevealText } from '../motion/Reveal';
import { TiltCard } from '../motion/TiltCard';
import { useMotionMode } from '../../contexts/MotionContext';

const ServiceCard = ({ service, index, cinematic }) => (
  <Reveal delay={(index % 3) * 0.12}>
    <Link to={`/services/${service.slug}`} data-testid={`service-card-${service.slug}`}>
      <TiltCard enabled={cinematic} className="group bg-white border border-gray-200 overflow-hidden h-full transition-shadow duration-500 hover:shadow-2xl">
        <div className="aspect-[4/3] overflow-hidden relative">
          <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-[transform,filter] duration-[1200ms] ease-out group-hover:scale-110 grayscale group-hover:grayscale-0" />
          <span className="absolute top-4 left-4 text-[11px] font-mono tracking-[0.2em] text-white mix-blend-difference">{String(index + 1).padStart(2, '0')}</span>
        </div>
        <div className="p-6">
          <h3 className="text-2xl font-bold mb-3 text-black">{service.title}</h3>
          <p className="text-gray-600 mb-4 line-clamp-2">{service.description}</p>
          <div className="flex items-center text-black">
            <span className="text-sm font-medium relative after:absolute after:left-0 after:-bottom-0.5 after:h-px after:w-full after:bg-black after:origin-left after:scale-x-0 group-hover:after:scale-x-100 after:transition-transform after:duration-500">Learn More</span>
            <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-2" />
          </div>
        </div>
      </TiltCard>
    </Link>
  </Reveal>
);

export const ServicesGrid = () => {
  const { cinematic } = useMotionMode();
  return (
    <section className="py-24 lg:py-32 bg-gray-50" data-testid="home-services">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">What we do</p>
            <h2 className="text-4xl md:text-5xl font-bold text-black tracking-tight"><RevealText text="Our Services" /></h2>
          </div>
          <Reveal className="text-base md:text-lg text-gray-600 max-w-md">Comprehensive chauffeur solutions tailored to your needs.</Reveal>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" style={{ perspective: 1200 }}>
          {services.map((s, i) => <ServiceCard key={s.id} service={s} index={i} cinematic={cinematic} />)}
        </div>
        <Reveal className="mt-14">
          <Link to="/services">
            <Button size="lg" variant="outline" className="border-2 border-black text-black hover:bg-black hover:text-white rounded-none px-8" data-testid="home-view-services-btn">
              View All Services
            </Button>
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
